import {
  isImageFile,
  getNonImageFileThumbnail,
} from "@/helpers/uploadDownloadHelper";
import {
  MutabakatMusteriQueryModel,
  UploadFile,
  DosyaUploadDto,
  MutabakatMusteriListModel,
  MutabakatStatListDto,
  MutabakatMusteriInfoModel,
  EkstreTalepDto,
} from "@emutabakat-types/musteriMutabakat";
import {
  MutabakatTableSettingsDto,
  KarsiMutabakatTableSettingsDto,
  MutabakatDto,
  MutabakatMusteriListItemDto,
  MutabakatMusteriQueryDto,
  MutabakatFilterDto,
  MutabakatMusteriTableSettingsDto,
  MutabakatMusteriFormDto,
  MutabakatMusteriEkstreTableSettingsDto,
  MutabakatMusteriDto,
  MutabakatMusteriEkstreDto,
  MutabakatMusteriDosyaDto,
  MutabakatListDto,
  NotificationDto,
  MutabakatMusteriFilterDto,
  SelectListDto,
  MutabakatMusteriEkstreFilterDto,
  MutabakatMusteriBakiyeDto,
  MultiButtonDto,
  MutabakatMusteriNotDto,
  MutabakatMusteriList,
  MutabakatExcelDto,
  MutabakatExcelListDto,
  UpdateBakiyeMutabakatMusteriListDto,
} from "@emutabakat-types/mutabakat";
import {
  saveState,
  getPersistedState,
  LocalStorageStates,
} from "@/helpers/localStorageHelper";
import { FILE_EXPORT_DATE_FORMAT } from "@/helpers/dateTimeHelper";
import { model } from "@arkas/core";
import moment from "moment";
import store from "@/store";
import { Upload } from "@arkas/coreui";
import { KarsiMutabakatItemDto } from "@emutabakat-types/anaveri";

store.subscribe(() => {
  saveState("mutabakat.state", {
    mutabakatModel: store.getState().mutabakatModel,
  });
});

export const base64ToUint8Array = (base64: string) => {
  const binary_string = atob(base64);
  const len = binary_string.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes;
};

export const base64ToArrayBuffer = (base64: string) => {
  const bytes = base64ToUint8Array(base64);
  return bytes.buffer;
};

const createBlob = (file: MutabakatMusteriDosyaDto) => {
  const blob = new Blob([base64ToArrayBuffer(file.fileContent) as BlobPart], {
    type: file.fileContentType,
  });
  return blob;
};

const createBlobExcel = (file: string) => {
  const blob = new Blob([base64ToArrayBuffer(file) as BlobPart], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  return blob;
};

interface MutabakatStateModelDto {
  queryModel: MutabakatMusteriQueryDto | undefined;
  mutabakatMusteriList: MutabakatMusteriListItemDto[] | undefined;
  model: MutabakatDto | undefined;
  mutabakatMusteriModel: MutabakatMusteriDto | undefined;
  mutabakatMusteriEkstreList: MutabakatMusteriEkstreDto[];
  karsiMutabakatList: KarsiMutabakatItemDto[] | undefined;
  mutabakatExcelFaturaList: MutabakatExcelDto[];
  mutabakatExcelBelgeList: MutabakatExcelDto[];
  mutabakatMusteriDosyaEkstreList: MutabakatExcelDto[];
  mutabakatEkstreDifferece: string;
  mutabakatMusteriTalepEkstreList: MutabakatMusteriEkstreDto[];
  mutabakatMusteriNotList: MutabakatMusteriNotDto[];
  mutabakatMusteriEkDosyaList: MutabakatMusteriDosyaDto[];
  mutabakatMusteriEkstreModel: MutabakatMusteriEkstreDto | undefined;
  mutabakatMusteriBakiyeModel: MutabakatMusteriBakiyeDto | undefined;
  baBsMusteriUpdateModel: MutabakatMusteriBakiyeDto | undefined;
  list: MutabakatListDto;
  tableSettings: MutabakatTableSettingsDto;
  karsiMutabakatTableSettings: KarsiMutabakatTableSettingsDto;
  detailTableSettings: MutabakatMusteriTableSettingsDto;
  mutabakatMusteriDetailTableSettings: MutabakatMusteriEkstreTableSettingsDto;
  ekstreTableSettings: MutabakatMusteriEkstreTableSettingsDto;
  belgeEkstreTableSettings: MutabakatMusteriEkstreTableSettingsDto;
  baBsTableSettings: MutabakatTableSettingsDto;
  baBsDetailTableSettings: MutabakatMusteriTableSettingsDto;
  baBsMutabakatMusteriDetailTableSettings: MutabakatMusteriEkstreTableSettingsDto;
  currentFilter: MutabakatMusteriQueryDto;
  currentMutabakatFilter: MutabakatFilterDto;
  currentMutabakatMusteriFilter: MutabakatMusteriFilterDto;
  currentBaBsFilter: MutabakatFilterDto;
  currentBaBsMutabakatMusteriFilter: MutabakatMusteriFilterDto;
  musteriBakiyeList: MutabakatMusteriListModel;
  mutabakatStat: MutabakatStatListDto;
  hataListesi: string[];
  onaydakilerTableSettings: MutabakatTableSettingsDto;
  onaylananlarTableSettings: MutabakatTableSettingsDto;
  reddedilenlerTableSettings: MutabakatTableSettingsDto;
  notifications: NotificationDto[];
  random: number;
  musteriList: SelectListDto[];
  kullaniciList: SelectListDto[];
  belgeTuruList: SelectListDto[];
  sirketList: SelectListDto[];
  onaydakiAdet: number;
  onaydakiMusteriSaticiAdet: number;
  onaydakiBaBsAdet: number;
  onaylananAdet: number;
  reddedilenAdet: number;
  queryBaslatmaTarihiText: string;
  queryAcikKalemAnahtarTarihiText: string;
  mutabakatMusteriListDto: MutabakatMusteriList[];
  mutabakatMusteriTekilMi: string;
}

// Local Storage'dan initial state alınıyor.
const persistedState: string | null = getPersistedState(
  LocalStorageStates.mutabakatState
);
const mutabakatState = persistedState
  ? JSON.parse(persistedState).mutabakatModel
  : undefined;

const initialState: MutabakatStateModelDto = {
  queryModel: undefined,
  model: undefined,
  mutabakatMusteriModel: undefined,
  mutabakatMusteriEkstreList: [],
  karsiMutabakatList: [],
  mutabakatExcelFaturaList: [],
  mutabakatExcelBelgeList: [],
  mutabakatMusteriDosyaEkstreList: [],
  mutabakatEkstreDifferece: "",
  mutabakatMusteriTalepEkstreList: [],
  mutabakatMusteriNotList: [],
  mutabakatMusteriEkDosyaList: [],
  mutabakatMusteriEkstreModel: undefined,
  mutabakatMusteriBakiyeModel: undefined,
  baBsMusteriUpdateModel: undefined,
  mutabakatMusteriList: [],
  list: { data: [], count: 0 },
  tableSettings: {
    pageSize: 5,
    currentPage: 1,
  },
  detailTableSettings: {
    pageSize: 50,
    currentPage: 1,
  },
  mutabakatMusteriDetailTableSettings: {
    pageSize: 10,
    currentPage: 1,
  },
  belgeEkstreTableSettings: {
    pageSize: 10,
    currentPage: 1,
  },
  baBsTableSettings: {
    pageSize: 5,
    currentPage: 1,
  },
  baBsDetailTableSettings: {
    pageSize: 5,
    currentPage: 1,
  },
  ekstreTableSettings: {
    pageSize: 25,
    currentPage: 1,
  },
  karsiMutabakatTableSettings: {
    pageSize: 25,
    currentPage: 1,
  },
  baBsMutabakatMusteriDetailTableSettings: {
    pageSize: 10,
    currentPage: 1,
  },
  onaydakilerTableSettings: {
    pageSize: 3,
    currentPage: 1,
  },
  onaylananlarTableSettings: {
    pageSize: 3,
    currentPage: 1,
  },
  reddedilenlerTableSettings: {
    pageSize: 3,
    currentPage: 1,
  },
  currentFilter: {},
  currentMutabakatFilter: {
    baBsMi: false,
    arsivlendiMi: false,
    sadeceKendiMutabakatlarim: false,
    pageIndex: 1,
    pageSize: 4,
  },
  currentMutabakatMusteriFilter: {
    sadeceKendiMutabakatlarim: false,
    pageSize: 50,
    pageIndex: 0,
  },
  currentBaBsFilter: {
    baBsMi: true,
    arsivlendiMi: false,
    sadeceKendiMutabakatlarim: false,
    pageIndex: 1,
    pageSize: 4,
  },
  currentBaBsMutabakatMusteriFilter: {
    sadeceKendiMutabakatlarim: false,
    pageSize: 50,
    pageIndex: 0,
  },
  musteriBakiyeList: { data: [], count: 0 },
  mutabakatStat: { yilListesi: [], adetListesi: [] },
  hataListesi: [],
  notifications: mutabakatState ? mutabakatState.notifications : [],
  random: mutabakatState ? mutabakatState.random : 0,
  musteriList: [],
  kullaniciList: [],
  belgeTuruList: [],
  sirketList: [],
  onaydakiAdet: 0,
  onaydakiMusteriSaticiAdet: 0,
  onaydakiBaBsAdet: 0,
  onaylananAdet: 0,
  reddedilenAdet: 0,
  queryBaslatmaTarihiText: "",
  queryAcikKalemAnahtarTarihiText: "",
  mutabakatMusteriListDto: [],
  mutabakatMusteriTekilMi: "",
};

export default model({
  config: {
    apiName: "mutabakat",
    name: "mutabakatModel",
    initialState,
  },
  hubs: {
    emutabakathub: {
      autoConnect: true,
      logging: true,
      listeners: {
        ReceiveMessage(message: NotificationDto) {
          const user = store.getState().kullaniciModel.currentUser;
          if (message.kullaniciId === user.id) {
            this.setRandom(Math.random());
          }
        },
      },
    },
  },
  reducers: {
    setNotifications(state, notifications) {
      return { ...state, notifications };
    },
    set(state, model: MutabakatDto | undefined) {
      return { ...state, model };
    },
    setMutabakatMusteri(
      state,
      mutabakatMusteriModel: MutabakatMusteriDto | undefined
    ) {
      return { ...state, mutabakatMusteriModel };
    },
    setMutabakatMusteriListDto(
      state,
      mutabakatMusteriListDto: MutabakatMusteriList[]
    ) {
      return { ...state, mutabakatMusteriListDto };
    },
    setMutabakatMusteriTekilMi(state, mutabakatMusteriTekilMi) {
      return { ...state, mutabakatMusteriTekilMi };
    },
    setCurrentMutabakatMusteriFilter(
      state,
      currentMutabakatMusteriFilter: MutabakatMusteriFilterDto
    ) {
      return { ...state, currentMutabakatMusteriFilter };
    },
    resetCurrentMutabakatMusteriFilter(state) {
      const currentMutabakatMusteriFilter: MutabakatMusteriFilterDto =
        initialState.currentMutabakatMusteriFilter;
      return { ...state, currentMutabakatMusteriFilter };
    },
    setMutabakatMusteriEkstre(
      state,
      mutabakatMusteriEkstreModel: MutabakatMusteriEkstreDto | undefined
    ) {
      return { ...state, mutabakatMusteriEkstreModel };
    },
    setMutabakatMusteriBakiye(
      state,
      mutabakatMusteriBakiyeModel: MutabakatMusteriBakiyeDto | undefined
    ) {
      return { ...state, mutabakatMusteriBakiyeModel };
    },
    setKarsiOnayMutabakatList(
      state,
      karsiOnayMutabakatList: KarsiMutabakatItemDto | undefined
    ) {
      return { ...state, karsiOnayMutabakatList };
    },
    setBaBsMusteriUpdate(
      state,
      baBsMusteriUpdateModel: MutabakatMusteriBakiyeDto | undefined
    ) {
      return { ...state, baBsMusteriUpdateModel };
    },
    setCurrentFilter(state, currentMutabakatFilter: MutabakatFilterDto) {
      return { ...state, currentMutabakatFilter };
    },
    resetCurrentFilter(state) {
      const currentMutabakatFilter: MutabakatFilterDto =
        initialState.currentMutabakatFilter;
      return { ...state, currentMutabakatFilter };
    },
    setMutabakatMusteriEkstreList(
      state,
      currentMutabakatMusteriEkstreList: MutabakatMusteriEkstreDto[]
    ) {
      return { ...state, currentMutabakatMusteriEkstreList };
    },
    resetMutabakatMusteriEkstreList(state) {
      const currentMutabakatMusteriEkstreList: MutabakatMusteriEkstreDto[] =
        initialState.mutabakatMusteriEkstreList;
      return { ...state, currentMutabakatMusteriEkstreList };
    },
    setMutabakatExcelFaturaList(
      state,
      mutabakatExcelFaturaList: MutabakatExcelDto[]
    ) {
      return { ...state, mutabakatExcelFaturaList };
    },
    resetMutabakatExcelFaturaList(state) {
      const mutabakatExcelFaturaList: MutabakatExcelDto[] =
        initialState.mutabakatExcelFaturaList;
      return { ...state, mutabakatExcelFaturaList };
    },
    setMutabakatMusteriTalepEkstreList(
      state,
      currentMutabakatMusteriTalepEkstreList: MutabakatMusteriEkstreDto[]
    ) {
      return { ...state, currentMutabakatMusteriTalepEkstreList };
    },
    resetMutabakatMusteriTalepEkstreList(state) {
      const currentMutabakatMusteriTalepEkstreList: MutabakatMusteriEkstreDto[] =
        initialState.mutabakatMusteriTalepEkstreList;
      return { ...state, currentMutabakatMusteriTalepEkstreList };
    },
    setMutabakatMusteriNotList(
      state,
      currentMutabakatMusteriNotList: MutabakatMusteriNotDto[]
    ) {
      return { ...state, currentMutabakatMusteriNotList };
    },
    resetMutabakatMusteriNotList(state) {
      const currentMutabakatMusteriNotList: MutabakatMusteriNotDto[] =
        initialState.mutabakatMusteriNotList;
      return { ...state, currentMutabakatMusteriNotList };
    },
    setMutabakatMusteriEkDosyaList(
      state,
      currentMutabakatMusteriEkDosyaList: MutabakatMusteriDosyaDto[]
    ) {
      return { ...state, currentMutabakatMusteriEkDosyaList };
    },
    resetMutabakatMusteriEkDosyaList(state) {
      const currentMutabakatMusteriEkDosyaList: MutabakatMusteriDosyaDto[] =
        initialState.mutabakatMusteriEkDosyaList;
      return { ...state, currentMutabakatMusteriEkDosyaList };
    },
    setCurrentBaBsFilter(state, currentBaBsFilter: MutabakatFilterDto) {
      return { ...state, currentBaBsFilter };
    },
    resetCurrentBaBsFilter(state) {
      const currentBaBsFilter: MutabakatFilterDto =
        initialState.currentBaBsFilter;
      return { ...state, currentBaBsFilter };
    },
    setCurrentBaBsMutabakatMusteriFilter(
      state,
      currentBaBsMutabakatMusteriFilter: MutabakatMusteriFilterDto
    ) {
      return { ...state, currentBaBsMutabakatMusteriFilter };
    },
    resetCurrentBaBsMutabakatMusteriFilter(state) {
      const currentBaBsMutabakatMusteriFilter: MutabakatMusteriFilterDto =
        initialState.currentBaBsMutabakatMusteriFilter;
      return { ...state, currentBaBsMutabakatMusteriFilter };
    },
    setCurrentMutabakatMusteriQuery(
      state,
      currentFilter: MutabakatMusteriQueryDto
    ) {
      return { ...state, currentFilter };
    },
    resetCurrentMutabakatMusteriQuery(state) {
      const currentFilter: MutabakatMusteriQueryDto =
        initialState.currentFilter;
      return { ...state, currentFilter };
    },
    setTableSettings(state, tableSettings) {
      return { ...state, tableSettings };
    },
    resetTableSettings(state) {
      return {
        ...state,
        tableSettings: initialState.tableSettings,
      };
    },
    setBaBsTableSettings(state, baBsTableSettings) {
      return { ...state, baBsTableSettings };
    },
    resetBaBsTableSettings(state) {
      return {
        ...state,
        tableSettings: initialState.baBsDetailTableSettings,
      };
    },
    setDetailTableSettings(state, detailTableSettings) {
      return { ...state, detailTableSettings };
    },
    resetDetailTableSettings(state) {
      return {
        ...state,
        detailTableSettings: initialState.detailTableSettings,
      };
    },
    setBaBsDetailTableSettings(state, baBsDetailTableSettings) {
      return { ...state, baBsDetailTableSettings };
    },
    resetBaBsDetailTableSettings(state) {
      return {
        ...state,
        baBsDetailTableSettings: initialState.baBsDetailTableSettings,
      };
    },
    setMutabakatMusteriDetailTableSettings(
      state,
      mutabakatMusteriDetailTableSettings
    ) {
      return { ...state, mutabakatMusteriDetailTableSettings };
    },
    resetMutabakatMusteriDetailTableSettings(state) {
      return {
        ...state,
        mutabakatMusteriDetailTableSettings:
          initialState.mutabakatMusteriDetailTableSettings,
      };
    },
    setFaturaEkstreTableSettings(state, ekstreTableSettings) {
      return { ...state, ekstreTableSettings };
    },
    resetFaturaEkstreTableSettings(state) {
      return {
        ...state,
        ekstreTableSettings: initialState.ekstreTableSettings,
      };
    },
    setKarsiMutabakatTableSettingsDto(state, karsiMutabakatTableSettings) {
      return { ...state, karsiMutabakatTableSettings };
    },
    resetKarsiMutabakatTableSettingsDto(state) {
      return {
        ...state,
        karsiMutabakatTableSettings: initialState.karsiMutabakatTableSettings,
      };
    },
    setBelgeEkstreTableSettings(state, belgeEkstreTableSettings) {
      return { ...state, belgeEkstreTableSettings };
    },
    resetBelgeEkstreTableSettings(state) {
      return {
        ...state,
        belgeEkstreTableSettings: initialState.belgeEkstreTableSettings,
      };
    },
    setBaBsMutabakatMusteriDetailTableSettings(
      state,
      baBsMutabakatMusteriDetailTableSettings
    ) {
      return { ...state, baBsMutabakatMusteriDetailTableSettings };
    },
    resetBaBsMutabakatMusteriDetailTableSettings(state) {
      return {
        ...state,
        baBsMutabakatMusteriDetailTableSettings:
          initialState.baBsMutabakatMusteriDetailTableSettings,
      };
    },
    setOnaydakilerTableSettings(state, onaydakilerTableSettings) {
      return { ...state, onaydakilerTableSettings };
    },
    setOnaylananlarTableSettings(state, onaylananlarTableSettings) {
      return { ...state, onaylananlarTableSettings };
    },
    setReddedilenlerTableSettings(state, reddedilenlerTableSettings) {
      return { ...state, reddedilenlerTableSettings };
    },
    setOnaydakiAdet(state, onaydakiAdet) {
      return { ...state, onaydakiAdet };
    },
    setOnaydakiMusteriSaticiAdet(state, onaydakiMusteriSaticiAdet) {
      return { ...state, onaydakiMusteriSaticiAdet };
    },
    setOnaydakiBaBsAdet(state, onaydakiBaBsAdet) {
      return { ...state, onaydakiBaBsAdet };
    },
    setOnaylananAdet(state, onaylananAdet) {
      return { ...state, onaylananAdet };
    },
    setReddedilenAdet(state, reddedilenAdet) {
      return { ...state, reddedilenAdet };
    },
    setRandom(state, random) {
      return { ...state, random };
    },
    resetOnaydakilerTableSettings(state) {
      return {
        ...state,
        onaydakilerTableSettings: initialState.onaydakilerTableSettings,
      };
    },
    resetOnaylananlarTableSettings(state) {
      return {
        ...state,
        onaylananlarTableSettings: initialState.onaylananlarTableSettings,
      };
    },
    resetReddedilenlerTableSettings(state) {
      return {
        ...state,
        reddedilenlerTableSettings: initialState.reddedilenlerTableSettings,
      };
    },
    resetOnaydakiAdet(state) {
      return {
        ...state,
        onaydakiAdet: initialState.onaydakiAdet,
      };
    },
    resetOnaydakiMusteriSaticiAdet(state) {
      return {
        ...state,
        onaydakiMusteriSaticiAdet: initialState.onaydakiMusteriSaticiAdet,
      };
    },
    resetOnaydakiBaBsAdet(state) {
      return {
        ...state,
        onaydakiBaBsAdet: initialState.onaydakiBaBsAdet,
      };
    },
    resetOnaylananAdet(state) {
      return {
        ...state,
        onaylananAdet: initialState.onaylananAdet,
      };
    },
    resetReddedilenAdet(state) {
      return {
        ...state,
        reddedilenAdet: initialState.reddedilenAdet,
      };
    },
    setQueryBaslatmaTarihiText(state, queryBaslatmaTarihiText) {
      return { ...state, queryBaslatmaTarihiText };
    },
    resetQueryBaslatmaTarihiText(state) {
      return {
        ...state,
        queryBaslatmaTarihiText: initialState.queryBaslatmaTarihiText,
      };
    },
    setQueryAcikKalemAnahtarTarihiTarihiText(
      state,
      queryAcikKalemAnahtarTarihiText
    ) {
      return { ...state, queryAcikKalemAnahtarTarihiText };
    },
    resetQueryAcikKalemAnahtarTarihiTarihiText(state) {
      return {
        ...state,
        queryAcikKalemAnahtarTarihiText:
          initialState.queryAcikKalemAnahtarTarihiText,
      };
    },
    receiveMusteriList(state, musteriList) {
      return { ...state, musteriList };
    },
    receiveKullaniciList(state, kullaniciList) {
      return { ...state, kullaniciList };
    },
    receiveBelgeTuruList(state, belgeTuruList) {
      return { ...state, belgeTuruList };
    },
    receiveSirketList(state, sirketList) {
      return { ...state, sirketList };
    },
  },
  effects: {
    async acikKalemAktarimiBaslat(id: number): Promise<void> {
      await this.postAsync<number>(
        `AcikKalemAktarimiBaslatAsync/${id}`,
        undefined,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
    },
    async ekstreAktarimiBaslat(id: number): Promise<void> {
      await this.postAsync<number>(
        `EkstreAktarimiBaslatAsync/${id}`,
        undefined,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
    },
    async mutabakatBaslat(model: MutabakatMusteriQueryDto): Promise<void> {
      model.baslatmaTarihi = model.baslatmaTarihi
        ? model.baslatmaTarihi._d
        : model.acikKalemAnahtarTarihi._d;
      model.acikKalemAnahtarTarihi = model.baslatmaTarihi
        ? model.baslatmaTarihi._d
        : model.acikKalemAnahtarTarihi._d;
      await this.postAsync<MutabakatMusteriListItemDto[]>(
        "MutabakatBaslatAsync",
        model,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
    },
    async getAllDataByFilter(
      model: MutabakatFilterDto
    ): Promise<Partial<MutabakatStateModelDto>> {
      model.baslangicTarihiText =
        model.baslangicTarihi === undefined ||
        model.baslangicTarihi === "" ||
        model.baslangicTarihi === null
          ? ""
          : `${model.baslangicTarihi._d.getDate()}.${model.baslangicTarihi._d.getMonth() +
              1}.${model.baslangicTarihi._d.getFullYear()}`;

      model.bitisTarihiText =
        model.bitisTarihi === undefined ||
        model.bitisTarihi === "" ||
        model.bitisTarihi === null
          ? ""
          : `${model.bitisTarihi._d.getDate()}.${model.bitisTarihi._d.getMonth() +
              1}.${model.bitisTarihi._d.getFullYear()}`;

      const response = await this.postAsync<MutabakatListDto>(
        "GetAllDataByFilterAsync",
        model
      );
      return { list: response };
    },
    async getById(
      searchModel: MutabakatMusteriFilterDto
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.postAsync<MutabakatDto>(
        `GetByIdAsync`,
        searchModel,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { model: response };
    },
    async getMutabakatMusteriListAsync(
      searchModel: MutabakatMusteriFilterDto
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.getAsync<MutabakatMusteriList[]>(
        `getMutabakatMusteriListAsync`,
        searchModel,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { mutabakatMusteriListDto: response };
    },
    async getMutabakatMusteriById(
      id: string
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.getAsync<MutabakatMusteriDto>(
        `GetMutabakatMusteriByIdAsync/${id}`,
        undefined,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { mutabakatMusteriModel: response };
    },
    ////////////buradayım////////////////
    async getMutabakatMusteriExtreId(
      id: string
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.getAsync<MutabakatExcelListDto>(
        `GetExtreComparationAsync/${id}`,
        undefined,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );

      return {
        mutabakatExcelFaturaList: response.ekstreList.filter(
          (item) => item.eslestiMi == false
        ),
        mutabakatExcelBelgeList: response.ekstreList,
      };
    },

    async getMutabakatMusteriEkstreById(
      id: string
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.getAsync<MutabakatMusteriEkstreDto>(
        `GetMutabakatMusteriEkstreByIdAsync/${id}`,
        undefined,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { mutabakatMusteriEkstreModel: response };
    },
    async getMutabakatMusteriBakiyeById(
      id: string
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.getAsync<MutabakatMusteriBakiyeDto>(
        `GetMutabakatMusteriBakiyeByIdAsync/${id}`,
        undefined,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { mutabakatMusteriBakiyeModel: response };
    },
    async getBaBsMusteriModelById(
      id: string
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.getAsync<MutabakatMusteriBakiyeDto>(
        `GetMutabakatMusteriBakiyeByIdAsync/${id}`,
        undefined,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { baBsMusteriUpdateModel: response };
    },
    async getMutabakatMusteriEkstreByFilter(
      searchModel: MutabakatMusteriEkstreFilterDto
    ): Promise<Partial<MutabakatStateModelDto>> {
      searchModel.belgeBaslangicTarihText =
        searchModel.belgeBaslangicTarih === undefined ||
        searchModel.belgeBaslangicTarih === "" ||
        searchModel.belgeBaslangicTarih === null
          ? ""
          : `${searchModel.belgeBaslangicTarih._d.getDate()}.${searchModel.belgeBaslangicTarih._d.getMonth() +
              1}.${searchModel.belgeBaslangicTarih._d.getFullYear()}`;

      searchModel.belgeBitisTarihText =
        searchModel.belgeBitisTarih === undefined ||
        searchModel.belgeBitisTarih === "" ||
        searchModel.belgeBitisTarih === null
          ? ""
          : `${searchModel.belgeBitisTarih._d.getDate()}.${searchModel.belgeBitisTarih._d.getMonth() +
              1}.${searchModel.belgeBitisTarih._d.getFullYear()}`;
      const response = await this.postAsync<MutabakatMusteriEkstreDto[]>(
        `GetMutabakatMusteriEkstreByFilterAsync`,
        searchModel,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      if (searchModel.ekstreMi === true) {
        return { mutabakatMusteriTalepEkstreList: response };
      }
      return { mutabakatMusteriEkstreList: response };
    },
    async getMutabakatMusteriNotList(
      id: string
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.getAsync<MutabakatMusteriNotDto[]>(
        `GetMutabakatMusteriNotList/${id}`,
        undefined,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { mutabakatMusteriNotList: response };
    },
    async getMutabakatMusteriEkDosyaList(
      id: string
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.getAsync<MutabakatMusteriDosyaDto[]>(
        `GetMutabakatMusteriEkDosya/${id}`,
        undefined,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { mutabakatMusteriEkDosyaList: response };
    },
    async getAllKullaniciNotifikasyon(
      id: string
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.getAsync<NotificationDto[]>(
        `GetAllKullaniciNotifikasyonAsync/${id}`,
        undefined,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { notifications: response };
    },
    async deleteAllKullaniciNotifikasyon(
      id: string
    ): Promise<Partial<MutabakatStateModelDto>> {
      await this.postAsync<NotificationDto[]>(
        `DeleteAllKullaniciNotifikasyonAsync/${id}`,
        undefined,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { notifications: [] };
    },
    async getMusteriList() {
      const list = await this.getAsync<SelectListDto[]>(`GetMusteriListAsync`);
      list.sort((a, b) => a.ad.localeCompare(b.ad));

      this.receiveMusteriList(list);
    },
    async getKullaniciList() {
      const list = await this.getAsync<SelectListDto[]>(
        `GetKullaniciListAsync`
      );
      list.sort((a, b) => a.ad.localeCompare(b.ad));

      this.receiveKullaniciList(list);
    },
    async getBelgeTuruList() {
      const list = await this.getAsync<SelectListDto[]>(
        `GetBelgeTuruListAsync`
      );
      list.sort((a, b) => a.ad.localeCompare(b.ad));

      this.receiveBelgeTuruList(list);
    },
    async getSirketList() {
      const list = await this.getAsync<SelectListDto[]>(`GetSirketListAsync`);
      list.sort((a, b) => a.ad.localeCompare(b.ad));

      this.receiveSirketList(list);
    },
  },
  methods: {
    async ekstreTalepEt(model: EkstreTalepDto): Promise<Partial<void>> {
      model.baslangicTarihiText =
        model.baslangicTarihi === undefined ||
        model.baslangicTarihi === "" ||
        model.baslangicTarihi === null
          ? ""
          : `${model.baslangicTarihi._d.getDate()}.${model.baslangicTarihi._d.getMonth() +
              1}.${model.baslangicTarihi._d.getFullYear()}`;
      await this.postAsync<boolean>(`EkstreTalepEtAsync`, model, {
        timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT),
      });
    },
    async ekstreTalebiOnayla(id: Number): Promise<void> {
      await this.postAsync<number>(`EkstreTalebiOnaylaAsync/${id}`, undefined, {
        timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT),
      });
    },
    async ekstreTalebiReddet(id: Number): Promise<void> {
      await this.postAsync<number>(`EkstreTalebiReddetAsync/${id}`, undefined, {
        timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT),
      });
    },
    async topluOnayaGonder(
      id: number,
      kendiMutabakatlarim: boolean,
      currentMutabakatMusteriFilter: MutabakatMusteriFilterDto
    ): Promise<void> {
      await this.postAsync<number>(
        `OnayaGonderAsync/${id}/${true}/${kendiMutabakatlarim}`,
        currentMutabakatMusteriFilter,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
    },
    async onayaGonder(
      id: Number,
      currentMutabakatMusteriFilter: MutabakatMusteriFilterDto
    ): Promise<void> {
      await this.postAsync<number>(
        `OnayaGonderAsync/${id}/${false}/${false}`,
        currentMutabakatMusteriFilter,
        {}
      );
    },
    async cokluOnayaGonder(model: MultiButtonDto): Promise<void> {
      await this.postAsync<number>(`CokluOnayaGonderAsync`, model, {
        timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT),
      });
    },
    async cokluGeriCek(model: MultiButtonDto): Promise<void> {
      await this.postAsync<number>(`CokluGeriCekAsync`, model, {
        timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT),
      });
    },
    async cokluSil(model: MultiButtonDto): Promise<void> {
      await this.postAsync<number>(`CokluSilAsync`, model, {
        timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT),
      });
    },
    async deleteMutabakatMusteri(id: string): Promise<void> {
      await this.postAsync<number>(
        `DeleteMutabakatMusteriAsync/${id}`,
        undefined,
        {}
      );
    },
    async onayGondermeBilgisiGuncelle(id: number): Promise<void> {
      await this.postAsync<number>(
        `OnayGondermeBilgisiGuncelleAsync/${id}`,
        undefined,
        {}
      );
    },

    async mutabakatYapilabilirMi(
      model: MutabakatMusteriQueryDto
    ): Promise<Partial<MutabakatStateModelDto>> {
      model.baslatmaTarihi = model.baslatmaTarihi._d;
      const response = await this.postAsync<string[]>(
        "MutabakatYapilabilirMiAsync",
        model,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { hataListesi: response };
    },

    async getDosya(fileName: string) {
      try {
        this.getAsync(`Download/${fileName}`, undefined, {
          responseType: "blob",
        })
          .then((response: string) => {
            if (response) {
              const blob = createBlobExcel(response);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
              } else {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName);
                document.body.appendChild(link);
                link.click();
              }
            }
          })
          .catch(() => {})
          .finally(() => {});
      } catch (error) {
        return false;
      }
    },

    async musteriBakiyeleriniGetir(
      searchModel: MutabakatMusteriQueryModel
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.getAsync<MutabakatMusteriListModel>(
        `MusteriBakiyeleriniGetirAsync`,
        searchModel,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { musteriBakiyeList: response };
    },

    async karsiMutabakatGetir(
      sirketId: string
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.getAsync<KarsiMutabakatItemDto[]>(
        `KarsiMutabakatGetirAsync/${sirketId}`,
        undefined
      );
      return { karsiMutabakatList: response };
    },

    async musteriBakiyeYillariniGetir(
      id: string
    ): Promise<Partial<MutabakatStateModelDto>> {
      const response = await this.getAsync<MutabakatStatListDto>(
        `MusteriBakiyeYillariniGetirAsync/${id}`,
        undefined,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
      return { mutabakatStat: response };
    },
    async statuDegistir(model: MutabakatMusteriFormDto): Promise<void> {
      await this.postAsync<void>(
        `MutabakatMusteriStatuDegistirAsync`,
        model,
        {}
      );
    },
    async updateMutabakatMusteriBakiye(
      input: MutabakatMusteriBakiyeDto
    ): Promise<void> {
      await this.postAsync<MutabakatMusteriBakiyeDto>(
        "UpdateMutabakatMusteriBakiyeAsync",
        input
      );
    },
    async updateMutabakatMusteriBakiyeBySap(
      model: UpdateBakiyeMutabakatMusteriListDto
    ): Promise<void> {
      await this.postAsync<number>(
        `UpdateMutabakatMusteriBakiyeBySapAsync`,
        model,
        { timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT) }
      );
    },
    async updateMutabakatMusteriEmail(
      input: MutabakatMusteriDto
    ): Promise<void> {
      await this.postAsync<MutabakatMusteriDto>(
        "UpdateMutabakatMusteriEmailAsync",
        input
      );
    },
    async saveMutabakatMusteriNot(
      input: MutabakatMusteriNotDto
    ): Promise<void> {
      await this.postAsync<string>("SaveMutabakatMusteriNot", input);
    },
    async arsivle(id: string): Promise<void> {
      await this.getAsync(`ArsivleAsync/${id}`, undefined, {
        timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT),
      });
    },
    async arsivdenGeriAl(id: string): Promise<void> {
      await this.getAsync(`ArsivdenGeriAlAsync/${id}`, undefined, {
        timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT),
      });
    },
    async uploadFile(
      newFile: File,
      mutabakatMusteriId: string,
      fileList: UploadFile[]
    ) {
      const formData = new FormData();
      const dosyaIdList = fileList.map((p) => p.id).toString();
      formData.append("File", newFile, newFile.name);
      formData.append("MutabakatMusteriId", mutabakatMusteriId);
      formData.append("DosyaIdList", dosyaIdList);
      const model = await this.postAsync<DosyaUploadDto>(
        "UploadAsync",
        formData,
        {
          timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT),
        }
      );

      if (model.isCorrectFormat === true) {
        const blobUrl = URL.createObjectURL(newFile);
        const thumbUrl = isImageFile(newFile.type)
          ? blobUrl
          : getNonImageFileThumbnail(newFile.type);
        const file: UploadFile = {
          id: model.id,
          uid: model.id ? model.id.toString() : "",
          name: newFile.name,
          type: newFile.type,
          status: "done",
          url: blobUrl,
          size: newFile.size,
          thumbUrl,
        };
        return file;
      } else {
        const file: UploadFile = {
          id: 0,
          uid: "",
          size: 0,
          name: "",
          type: "",
          status: "error",
          url: "",
          thumbUrl: "",
          error: "Dosya formatı hatalıdır.",
        };
        return file;
      }
    },
    async uploadEkDosya(
      newFile: File,
      mutabakatMusteriId: string,
      fileList: UploadFile[]
    ) {
      const formData = new FormData();
      const dosyaIdList = fileList.map((p) => p.id).toString();
      formData.append("File", newFile, newFile.name);
      formData.append("MutabakatMusteriId", mutabakatMusteriId);
      formData.append("DosyaIdList", dosyaIdList);
      const model = await this.postAsync<DosyaUploadDto>(
        "UploadEkDosyaAsync",
        formData,
        {
          timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT),
        }
      );
      const blobUrl = URL.createObjectURL(newFile);
      const thumbUrl = isImageFile(newFile.type)
        ? blobUrl
        : getNonImageFileThumbnail(newFile.type);
      const file: UploadFile = {
        id: model.id,
        uid: model.id ? model.id.toString() : "",
        name: newFile.name,
        type: newFile.type,
        status: "done",
        url: blobUrl,
        size: newFile.size,
        thumbUrl,
      };
      return file;
    },

    async uploadKarsiOnayDosya(newFile: File) {
      const formData = new FormData();
      formData.append("File", newFile, newFile.name);
      const model = await this.postAsync<DosyaUploadDto>(
        "UploadKarsiOnayDosyaAsync",
        formData,
        {
          timeout: Number(process.env.ARKAS_APP_REQUEST_TIMEOUT),
        }
      );
      const blobUrl = URL.createObjectURL(newFile);
      const thumbUrl = isImageFile(newFile.type)
        ? blobUrl
        : getNonImageFileThumbnail(newFile.type);
      const file: UploadFile = {
        id: model.id,
        uid: model.id ? model.id.toString() : "",
        name: newFile.name,
        type: newFile.type,
        status: "done",
        url: blobUrl,
        size: newFile.size,
        thumbUrl,
      };
      return file;
    },

    async removeFile(id: string): Promise<void> {
      await this.postAsync<void>(`RemoveFileAsync/${id}`, {});
    },
    async removeKarsiOnayDosya(id: string): Promise<void> {
      await this.postAsync<void>(`RemoveKarsiOnayDosyaAsync/${id}`, {});
    },
    async removeEkDosya(id: string): Promise<void> {
      await this.postAsync<void>(`RemoveEkDosyaAsync/${id}`, {});
    },
    async removeNot(id: string): Promise<void> {
      await this.postAsync<void>(`RemoveNotAsync/${id}`, {});
    },
    async createKarsiOnayMutabakat(
      id: string,
      sirketId: string
    ): Promise<void> {
      await this.postAsync<void>(
        `CreateKarsiOnayMutabakatAsync/${id}/${sirketId}`,
        {}
      );
    },
    async downloadFile(model: MutabakatMusteriDosyaDto) {
      try {
        this.postAsync(`DownloadAsync`, model, {
          responseType: "blob",
        })
          .then((response: MutabakatMusteriDosyaDto) => {
            if (response) {
              const blob = createBlob(response);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, model.fileName);
              } else {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", model.fileName);
                document.body.appendChild(link);
                link.click();
              }
            }
          })
          .catch(() => {})
          .finally(() => {});
      } catch (error) {
        return false;
      }
    },

    async ekstreExportExcel(searchModel: MutabakatMusteriEkstreFilterDto) {
      try {
        this.postAsync("EkstreExcelExportAsync", searchModel, {
          responseType: "blob",
        })
          .then((response: MutabakatMusteriDosyaDto) => {
            if (response) {
              const blob = createBlob(response);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(
                  blob,
                  `${searchModel.mutabakatMusteriAdi}_Ekstreler.xlsx`
                );
              } else {
                const name = searchModel.ekstreMi
                  ? `${searchModel.mutabakatMusteriAdi}_Ekstreler.xlsx`
                  : `${searchModel.mutabakatMusteriAdi}_AçıkKalemler.xlsx`;
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", name);
                document.body.appendChild(link);
                link.click();
              }
            }
          })
          .catch(() => {})
          .finally(() => {});
      } catch (error) {
        return false;
      }
    },
    async mutabakatMusteriExportExcel(searchModel: MutabakatMusteriFilterDto) {
      try {
        this.postAsync("MutabakatMusteriExcelExportAsync", searchModel, {
          responseType: "blob",
        })
          .then((response: MutabakatMusteriDosyaDto) => {
            if (!searchModel.isAll) {
              if (response) {
                let filePrefix = "Filtre";
                if (searchModel.mutabakatAdi) {
                  filePrefix = searchModel.mutabakatAdi;
                }
                const blob = createBlob(response);
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                  window.navigator.msSaveOrOpenBlob(
                    blob,
                    `${filePrefix}_MutabakatListesi.xlsx`
                  );
                } else {
                  const url = window.URL.createObjectURL(blob);
                  const link = document.createElement("a");
                  link.href = url;
                  link.setAttribute(
                    "download",
                    `${filePrefix}_MutabakatListesi.xlsx`
                  );
                  document.body.appendChild(link);
                  link.click();
                }
              }
            }
          })
          .catch(() => {})
          .finally(() => {});
      } catch (error) {
        return false;
      }
    },
    async bakiyeExportExcel(searchModel: MutabakatMusteriEkstreFilterDto) {
      try {
        this.postAsync("BakiyeExcelExportAsync", searchModel, {
          responseType: "blob",
        })
          .then((response: MutabakatMusteriDosyaDto) => {
            if (response) {
              const blob = createBlob(response);
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(
                  blob,
                  `${searchModel.mutabakatMusteriAdi}_Bakiyeler.xlsx`
                );
              } else {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                  "download",
                  `${searchModel.mutabakatMusteriAdi}_Bakiyeler.xlsx`
                );
                document.body.appendChild(link);
                link.click();
              }
            }
          })
          .catch(() => {})
          .finally(() => {});
      } catch (error) {
        return false;
      }
    },
    async cokluPrintAsync(model: MultiButtonDto) {
      try {
        this.postAsync("CokluPrintAsync", model, {
          responseType: "blob",
        })
          .then((response: MutabakatMusteriDosyaDto) => {
            if (response) {
              const tarih = new Date();
              const tarihText = tarih
                .toLocaleString("tr-TR")
                .split(".")
                .join("");
              const text = "MutabakatMektubu";
              const blob = createBlob(response);

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(
                  blob,
                  `${tarihText}_${text}.html`
                );
              } else {
                const w = window.open();
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = function() {
                  const base64string = reader.result;
                  if (base64string) {
                    const base64text = base64string.toString();
                    const splittedArray = base64text.split(",");
                    if (splittedArray.length > 1) {
                      const dataUri = splittedArray[1];
                      let html = atob(dataUri);
                      if (html && w) {
                        html = decodeURIComponent(escape(window.atob(dataUri)));
                        w.document.write(html);
                        w.window.print();
                        w.document.close();
                      }
                    }
                  }
                };
              }
            }
          })
          .catch(() => {})
          .finally(() => {});
      } catch (error) {
        return false;
      }
    },

    async mutabakatPrintHtml(
      model: MutabakatMusteriInfoModel,
      ingilizceMi: boolean
    ) {
      try {
        model.mektupIngilizceMi = ingilizceMi;
        this.postAsync("MutabakatPrintAsync", model, {
          responseType: "blob",
        })
          .then((response: MutabakatMusteriDosyaDto) => {
            if (response) {
              const text = ingilizceMi
                ? "ReconciliationLetter"
                : "MutabakatMektubu";
              const blob = createBlob(response);
              const tarih = moment(model.baslatmaTarihi).format(
                FILE_EXPORT_DATE_FORMAT
              );
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(
                  blob,
                  `${model.musteriUnvan}_${tarih}_${text}.html`
                );
              } else {
                const w = window.open();
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = function() {
                  const base64string = reader.result;
                  if (base64string) {
                    const base64text = base64string.toString();
                    const splittedArray = base64text.split(",");
                    if (splittedArray.length > 1) {
                      const dataUri = splittedArray[1];
                      let html = atob(dataUri);
                      if (html && w) {
                        html = decodeURIComponent(escape(window.atob(dataUri)));
                        w.document.write(html);
                        w.window.print();
                        w.document.close();
                      }
                    }
                  }
                };
              }
            }
          })
          .catch(() => {})
          .finally(() => {});
      } catch (error) {
        return false;
      }
    },
    async mutabakatExportHtml(
      model: MutabakatMusteriInfoModel,
      ingilizceMi: boolean
    ) {
      try {
        model.mektupIngilizceMi = ingilizceMi;
        this.postAsync("MutabakatExportAsync", model, {
          responseType: "blob",
        })
          .then((response: MutabakatMusteriDosyaDto) => {
            if (response) {
              const text = ingilizceMi
                ? "ReconciliationLetter"
                : "MutabakatMektubu";
              const blob = createBlob(response);
              const tarih = moment(model.baslatmaTarihi).format(
                FILE_EXPORT_DATE_FORMAT
              );
              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(
                  blob,
                  `${model.musteriUnvan}_${tarih}_${text}.html`
                );
              } else {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute(
                  "download",
                  `${model.musteriUnvan}_${tarih}_${text}.html`
                );
                document.body.appendChild(link);
                link.click();
              }
            }
          })
          .catch(() => {})
          .finally(() => {});
      } catch (error) {
        return false;
      }
    },
  },
});
